import { render, staticRenderFns } from "./Kaltwasser.vue?vue&type=template&id=64cda404&"
import script from "./Kaltwasser.vue?vue&type=script&lang=js&"
export * from "./Kaltwasser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports